module.exports = "<app-header></app-header>\r\n<app-questionnaire></app-questionnaire>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 344
// module chunks = 1